export const SOFTLINE_API_KOPFKOMM = '/v1/kopfkomm/entities';
export const SOFTLINE_API_KOPFKOMM_SPERRE = '/v1/kopfkomm/entities/{{id}}/sperre';
export const SOFTLINE_API_KOPFKOMM_ABSCHLUSS = '/v1/kopfkomm/{{id}}/abschluss';
export const SOFTLINE_API_KOPFKOMM_ABSCHLUSS_MISCHPALETTE =
  '/v1/kopfkomm/{{id}}/abschluss-mischpalette';

export const SOFTLINE_API_KOPFKOMM_BEGLEITSCHEINDRUCK =
  '/v1/kopfkomm/{{id}}/drucke-begleitscheine';

export const SOFTLINE_API_KOPFKOMM_ABSCHLUSS_MISCHPALETTE_DRUCK =
  '/v1/kopfkomm/{{id}}/drucke-vorkommission';

export const SOFTLINE_API_LAGERPLATZVORSCHLAG = '/v1/lagerplatzvorschlag/{{idbewekomm}}';
export const SOFTLINE_API_KOMMSCAN = '/v1/kommscan';
export const SOFTLINE_API_KOMMSCAN_MISCHPALETTE = '/v1/kommscan-mischpalette';
export const SOFTLINE_API_SCAN_LAGERPLATZ =
  '/v1/lagerplatzinhalt/scan-lagerplatz/{{code}}';
export const SOFTLINE_API_SCAN_PALETTE = '/v1/lagerplatzinhalt/scan-palette/{{code}}';
